import { billingMutationKeys } from '../../services/api/billing/mutations/billing-mutation-factory';

const purchaseOrderMutationKey = billingMutationKeys.createPurchaseOrder;
const orderIntentMutationKey = billingMutationKeys.createOrderIntent;

const purchaseOrderMutationFilter = {
  mutationKey: purchaseOrderMutationKey,
  exact: true
};

const orderIntentMutationFilter = {
  mutationKey: orderIntentMutationKey,
  exact: true
};

export * from './payment-button.component';
export * from './use-button-text';
export { orderIntentMutationFilter, purchaseOrderMutationFilter };
